import { CheckNullExpectType } from './../../share/enums-master';
import { SMILE9_API_ENDPOINT } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UtilService } from '../../share/util/util.service';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';

@Injectable()
export class RegisterFavService {
  controlerName = 'api/RegisterFav';
  subHttpClients = new Subscription();

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
  ) { }

  public getPassword(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/GetPassword`).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

}
